import React from 'react';
import { Outlet } from 'react-router-dom';

import { useAppSelector } from 'hooks';
import { selectExistsAuthToken } from 'redux/auth/selectors';
import { selectAccount } from 'redux/account/selectors';
import BaseLayout from '../BaseLayout';

const PublicLayout: React.FC = () => {
    const authorized = useAppSelector(selectExistsAuthToken);
    const account = useAppSelector(selectAccount);

    return (
        <BaseLayout authorized={authorized} isModerator={account?.is_moderator}>
            <Outlet />
        </BaseLayout>
    );
};

export default React.memo(PublicLayout);
